import { connectedStore } from '../../store';
import actions from '../actions';

function setPagesInNavigation(pageIds) {
  const store = connectedStore.get();
  store.dispatch(actions.setPagesInNavigation(pageIds));
}

export default setPagesInNavigation;
